import React from "react";
import styles from "./styles.module.scss";
import { FaPlay } from "react-icons/fa";
import Image from "next/image";
import Link from "next/link";
interface TikTokEmbedProps {
  videoId: string;
  username?: string;
  thumbnail?: string;
}

const TikTokEmbed: React.FC<TikTokEmbedProps> = ({
  videoId,
  username,
  thumbnail,
}) => {
  const videoUrl = `https://www.tiktok.com/@${username}/video/${videoId}`;

  return (
    <div className={styles.tiktokEmbed}>
      <Link
        href={videoUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="block relative group"
      >
        <Image
          src={thumbnail || ""}
          alt={`TikTok video by @${username}`}
          className="w-80 h-[500px] rounded-lg"
          width={320}
          height={500}
          unoptimized
        />
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300">
          <div className="transform scale-90 group-hover:scale-100 transition-transform duration-300">
            <FaPlay className="text-neutral-400 text-5xl" />
          </div>
        </div>
      </Link>
    </div>
  );
};

export default TikTokEmbed;
